/* eslint-disable */
// export const user = {
//     id    : 'cfaad35d-07a3-4447-a6c3-d8c3d54fd5df',
//     name  : 'Brian Hughes',
//     email : 'hughes.brian@company.com',
//     avatar: 'assets/images/avatars/brian-hughes.jpg',
//     status: 'online'
// };

export const user = {
    id    : 'cfaad35d-07a3-4447-a6c3-d8c3d54fd5df',
    name  : 'Admin',
    email : 'admin@bydcash.com',
    avatar: 'assets/images/avatars/brian-hughes.jpg',
    status: 'online'
};
